<template>
  <li class="nuttrema-list-item group" v-if="group.length > 0">
    <table>
      <colgroup>
        <col class="col-w-5">
        <col class="col-w-80">
        <col class="col-w-15">
      </colgroup>
      <thead>
        <tr class="group">
          <th colspan="3">{{ $t(`label.${title}`) }}</th>
        </tr>
        <tr class="item">
          <th class="cell-w-5"></th>
          <th class="cell-w-80">{{ $t('label.general_information') }}</th>
          <th class="cell-w-15"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="with-border-bottom" v-for="item in group">
          <td>
            <nuttrema-iconica-kcal
              :text="item.title || item.description"
              :energyKcal="item.energy_kcal">
            </nuttrema-iconica-kcal>
          </td>
          <td class="col-w-80">
            <div class="content-text">
              <p>{{ item.weight_gr }}g</p>
            </div>
            <div class="content-title">
              <h4>{{ item.title || item.description }}</h4>
            </div>
          </td>
          <td class="col-w-15">
            <router-link
               v-if="edit"
               class="el-button el-button--text"
              :to="{ name: meta.navigation.edit, params: { servingSizeID: item.id }}">
              {{ $t('label.view_detail') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </li>
</template>

<script>
import PageProps from 'components/mixins/page-props';
import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';
import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';

export default {
  name: 'cmpt-serving-sizes-list-item',
  mixins: [NuttremaIndexListItem, PageProps],
  components: {
    NuttremaIconicaKcal,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/serving-sizes/cmpt-serving-sizes-list-item.vue